<template>
  <div class="jobs-page">
	<Header></Header> <!-- 头部 -->
	<div class="content bg">
		<van-search
		  v-model="searchValue"
		  show-action
		  placeholder="请输入搜索关键词"
		>
		  <template #action>
		    <div @click="onSearch(1)"><van-button size="normal" type="info">搜索</van-button></div>
		  </template>
		</van-search>
		<div class="tag-list">
			<div class="tit">工作地点：</div>
			<div class="tags">
				<div class="address-tags" v-for="(item,index) in addressList">
					<van-tag v-if="index < 12" round type="default" @click="onSearch(item)" :name="item" :class="addressActive == item?'active':''">{{item}}</van-tag>
					<van-tag v-else round type="default" @click="onSearch(item)" :name="item" :class="addressActive == item?'address-more active':'address-more'">{{item}}</van-tag>
				</div>
			</div>
			<div class="s-more" v-if="isShowMore==false" @click="showMore"><van-icon name="arrow-down" />显示更多</div>
			<div class="s-more" v-else  @click="showMore"><van-icon name="arrow-up" />收起更多</div>
		</div>
		<div class="lists">
			<div class="tit">招聘职位：</div>
			<van-list
			  v-model="joa_loading"
			  :finished="joa_finished"
			  finished-text="没有更多了"
			  @load="onLoad"
			>
				<van-card  v-for="(item,index) in jobs_list" :id="item.id" @click="onDetail(item.id)">
					<!-- <div slot="title">
						<div v-if="item.post_object==2" class="van-card__tag">
							<span class="van-tag van-tag--mark van-tag--danger">内部应聘</span>
						</div>
						<div :class="item.post_object==2?'title s':'title'">{{item.post_title}}</div>
					</div>-->
					<div slot="title">
						<div class="title">{{item.post_title}}</div>
					</div>
					<div slot="desc" class="desc">
						<span v-if="item.post_area!=''">工作地点：{{item.post_area}}</span>
						<span v-if="item.post_sub_title!=''">招聘人数：{{item.post_sub_title}}</span>
					</div>
					<template #footer>
						<van-button round type="primary" size="info" @click="onDetail(item.id)">我要应聘</van-button>
					</template>
				</van-card>
			</van-list>
		</div>
		<Footer></Footer> <!-- 尾部 -->
	</div>
  </div>
</template>

<script type="text/javascript">
import axios from 'axios';
export default {
  created() {
		this.getData(); //获取数据	
  },
  mounted(){	
  },
  data() {
		return {
		  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
		  WEB_URL:this.CoreNew.WEB_URL,
		  JOA_URL:this.CoreNew.JOA_URL,
		  searchValue:"",
		  addressActive:"全部",
		  addressList:["全部","全国","北京","上海","广州","深圳","东莞","长沙","成都","重庆","福州","杭州","合肥","南京","宁波","青岛","厦门","苏州","天津","武汉","西安","郑州","珠海","香港","沈阳","台湾","新加坡"],
		  jobs_list: [],
		  joa_total:0,
		  joa_page:0,
		  joa_loading: false,
		  joa_finished: false,
		  searchs:[],
		  isShowMore:false
		};
   },
    methods: {
		showMore: function () {
			if(this.isShowMore==false){
				this.isShowMore=true;
				$(".address-more").show();
			}else{
				this.isShowMore=false;
				$(".address-more").hide();
			}
		},
		onLoad: function () {
		    //this.getData(); //获取数据
			//this.joa_loading = false;
			//if (this.jobs_list.length >= this.joa_total) {
			//	this.joa_finished = true;
			//}
		},
		//跳转详细页
		onDetail: function (id) {
			let url=this.WEB_URL+'jobsDetail?id='+id; 
			window.location.href=url;
		},
		onSearch: function (val) {
			if(val==1){
				this.searchs["area"]="";
				this.addressActive="全部";
				this.searchs["kw"]=encodeURIComponent(this.searchValue);
			}else{
				this.searchValue="";this.searchs["kw"]="";
				this.searchs["area"]=encodeURIComponent(val);
				this.addressActive=val;
			}
			this.jobs_list=[];
			this.joa_page=0;
			this.getData(); //搜索数据	
		},
	    getData: function () {
			this.joa_page++;this.joa_loading = true;
			let json_data = {
				page: this.joa_page,
				pageSize: this.CoreNew.PAGESIZE
			}
			if (this.searchs["kw"] && this.searchs["kw"]!="") {
				json_data["kw"] = this.searchs["kw"];
			} else if (this.searchs["area"] && this.searchs["area"]!="") {
				json_data["area"] = this.searchs["area"];
			}
			axios.get(this.CoreNew.CECPORT_URL+"icapi/getJobs/", { 
				params: json_data
			}).then(function (response) {
				if(response.data.status==1){
					if(response.data.kw && response.data.kw!=""){
						this.searchValue=response.data.kw;
					}
					if(response.data.post_area && response.data.post_area!=""){
						this.addressActive=response.data.post_area;
					}
					if(response.data.total==0){
						this.jobs_list=[];
						this.joa_loading = false;
						this.joa_finished = true;
						$(".no-datas").addClass("show");
					}else{
						var $rs=response.data;
						$(".no-datas").removeClass("show");
						this.joa_total=$rs.total;
						var $list=$rs.lists;
						this.jobs_list=this.jobs_list.concat($list);
						// 数据全部加载完成
						this.joa_loading = false;
						if (this.jobs_list.length !=0 && (this.jobs_list.length >= this.joa_total)) {
						  this.joa_finished = true;
						}else{
							this.getData(); //获取数据
						}
					}
				}
			}.bind(this)).catch(function (error) { 
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--招聘列表--失败"+error);//记录错误
				console.log("请求--招聘列表--失败"+error); 
			});
		}
    }
};
</script>